import React from 'react'
import PropTypes from 'prop-types'

import './measurement_guide.css'

const MeasurementGuide = ({ gender }) => {
  const normalizedGender = gender === 'Female' ? 'female' : 'male'

  return (
    <div className={`measurement-guide measurement-guide-${normalizedGender}`}>
      <img
        className="demoImage measurement-guide-image"
        src={`/images/measurement-guide-${normalizedGender}.png`}
        alt="Measurement location guide"
      />
      <div className="measurement-guide-labels" aria-hidden="true">
        <span className="measurement-guide-label measurement-guide-label-biceps">
          Biceps
        </span>
        <span className="measurement-guide-label measurement-guide-label-waist">
          Waist
        </span>
        <span className="measurement-guide-label measurement-guide-label-thigh">
          Thigh
        </span>
        <span className="measurement-guide-label measurement-guide-label-chest">
          {normalizedGender === 'female' ? 'Bust' : 'Chest'}
        </span>
        <span className="measurement-guide-label measurement-guide-label-hips">
          Hips
        </span>
      </div>
    </div>
  )
}

MeasurementGuide.propTypes = {
  gender: PropTypes.string.isRequired,
}

export default MeasurementGuide
